import { render, staticRenderFns } from "./AdminReimbursementPrefixList.vue?vue&type=template&id=47b69bf3"
import script from "./AdminReimbursementPrefixList.vue?vue&type=script&lang=js"
export * from "./AdminReimbursementPrefixList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports